module.exports = "/_next/static/images/logo-5e1d8e52a2a7efea3d894c4a75314f4c.svg";